import { render, staticRenderFns } from "./CNoticePopup.vue?vue&type=template&id=667c1001"
import script from "./CNoticePopup.vue?vue&type=script&lang=js"
export * from "./CNoticePopup.vue?vue&type=script&lang=js"
import style0 from "./CNoticePopup.vue?vue&type=style&index=0&id=667c1001&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('667c1001')) {
      api.createRecord('667c1001', component.options)
    } else {
      api.reload('667c1001', component.options)
    }
    module.hot.accept("./CNoticePopup.vue?vue&type=template&id=667c1001", function () {
      api.rerender('667c1001', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CNoticePopup.vue"
export default component.exports